import { render } from "./Keyboard.vue?vue&type=template&id=cca12e6a"
import script from "./Keyboard.vue?vue&type=script&lang=js"
export * from "./Keyboard.vue?vue&type=script&lang=js"

import "./Keyboard.vue?vue&type=style&index=0&id=cca12e6a&lang=css"

import exportComponent from "D:\\Dev\\devine-mot\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__